// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bDPIF","footer":"styles_footer__17zCG"};